// File: /opt/dev_environment/assets/workspace/app-init/src/services/storage.js

/**
 * Storage service — now a thin compatibility layer.
 * All actual data operations are handled by the API via VocabularyContext.
 * This file retains only the local settings cache for instant UI responsiveness
 * and the seed data check (which is now handled server-side on reset).
 */

const STORAGE_KEYS = {
  SETTINGS: 'vokabelkasten_settings',
};

const storage = {
  get(key) {
    try {
      const item = localStorage.getItem(key);
      return item ? JSON.parse(item) : null;
    } catch (error) {
      console.error(`Error reading from localStorage key "${key}":`, error);
      return null;
    }
  },

  set(key, value) {
    try {
      localStorage.setItem(key, JSON.stringify(value));
      return true;
    } catch (error) {
      console.error(`Error writing to localStorage key "${key}":`, error);
      return false;
    }
  },

  remove(key) {
    try {
      localStorage.removeItem(key);
      return true;
    } catch (error) {
      console.error(`Error removing localStorage key "${key}":`, error);
      return false;
    }
  },
};

/**
 * Local settings cache for instant UI responsiveness.
 * Settings are also synced to the backend via settingsApi.
 */
export const settingsLocalCache = {
  get() {
    return storage.get(STORAGE_KEYS.SETTINGS) || {
      queryDirection: 'IT→DE',
      selectedCompartment: 1,
      shuffleActive: false,
      trainingMode: 'vokabeln',
    };
  },

  save(settings) {
    return storage.set(STORAGE_KEYS.SETTINGS, settings);
  },

  update(updates) {
    const current = this.get();
    const updated = { ...current, ...updates };
    this.save(updated);
    return updated;
  },

  clear() {
    storage.remove(STORAGE_KEYS.SETTINGS);
  },
};

export function resetLocalData() {
  settingsLocalCache.clear();
  console.info('[Vokabelkasten] Local data cleared');
}

export default storage;